/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuperagentResponse = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Response2 = require('./Response');

var _LambdaResponse = require('./LambdaResponse');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let SuperagentResponse = exports.SuperagentResponse = function (_Response) {
  _inherits(SuperagentResponse, _Response);

  /**
   * @param {*} args
   */
  function SuperagentResponse() {
    var _ref;

    _classCallCheck(this, SuperagentResponse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = SuperagentResponse.__proto__ || Object.getPrototypeOf(SuperagentResponse)).call.apply(_ref, [this].concat(args)));

    if (_this._request.isLambda) {
      _this._parseLambda();
    } else {
      _this._parseExternal();
    }
    return _this;
  }

  /**
   * @returns {Object}
   */


  _createClass(SuperagentResponse, [{
    key: '_parseLambda',


    /**
     * @private
     */
    value: function _parseLambda() {
      this._parseExternal();

      // check if any Lambda response available
      if (this._data) {

        // manage this weird case...
        if (typeof this._data === 'string') {
          try {
            this._data = JSON.parse(this._data);
          } catch (e) {
            console.log('Unable to parse data: ', e);
          }
        }

        let dataObj = this._data;

        // check whether Lambda execution failed
        if (dataObj.errorMessage) {
          let errorObj = null;

          if (dataObj.errorStack && dataObj.errorType) {
            errorObj = dataObj;
          } else {
            errorObj = dataObj.errorMessage;

            if (typeof errorObj === 'string') {
              try {
                errorObj = JSON.parse(errorObj);
              } catch (e) {
                errorObj = {
                  errorMessage: errorObj,
                  errorStack: new Error('Internal error occurred.').stack,
                  errorType: 'InternalError'
                };
              }
            } else {
              errorObj = errorObj || {
                errorMessage: 'Unknown error occurred.',
                errorStack: new Error('Unknown error occurred.').stack,
                errorType: 'UnknownError'
              };
            }
          }

          this._error = _LambdaResponse.LambdaResponse.getPayloadError(errorObj);
          this._data = null;
        } else {
          this._data = dataObj;
        }
      }
    }

    /**
     * @private
     */

  }, {
    key: '_parseExternal',
    value: function _parseExternal() {
      let data = this._rawData;
      let error = this._rawError;

      if (error) {
        this._error = error;
      }

      if (data && data.error) {
        // weird case...
        this._error = data.error;
      }

      this._data = data && data.body ? data.body : null;

      // @todo: treat Response.status lack somehow else?
      if (data && data.status) {
        this._statusCode = parseInt(data.status);
      } else if (this._data && !this._error) {
        this._statusCode = 200;
      } else {
        if (this._error && typeof this._error === 'object' && this._error.crossDomain && typeof this._error.crossDomain.status === 'undefined') {

          this._statusCode = 403;
        } else {
          this._statusCode = this._error && typeof this._error === 'object' ? this._error.status || 500 : 500;
        }
      }
    }
  }, {
    key: 'headers',
    get: function get() {
      if (!this._headers) {
        // rawData in this case is superagent original Response object
        this._headers = this.rawData && this.rawData.headers ? this.rawData.headers : {};
      }

      return this._headers;
    }

    /**
     * @returns {String|null}
     */

  }, {
    key: 'requestId',
    get: function get() {
      if (!this._requestId && this.headers) {
        if (this.headers[_Response2.Response.ORIGINAL_REQUEST_ID_HEADER.toLowerCase()]) {
          this._requestId = this.headers[_Response2.Response.ORIGINAL_REQUEST_ID_HEADER.toLowerCase()];
        } else if (this.headers[_Response2.Response.REQUEST_ID_HEADER.toLowerCase()]) {
          this._requestId = this.headers[_Response2.Response.REQUEST_ID_HEADER.toLowerCase()];
        }
      }

      return this._requestId;
    }
  }]);

  return SuperagentResponse;
}(_Response2.Response);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/SuperagentResponse.js
// module id = 176
// module chunks = 0